import { Project } from "./Project";
import { PermitGangMember } from "./PermitGangMember";
import { PermitAffectedService } from "./PermitAffectedService";
import { Document } from "./PermitDocument";
import { LocationLog } from "./LocationLog";
import { EmergencyContact } from "./EmergencyContact";
import { PermitAssignment } from "./PermitAssignment";
import { PermitAuthorisationSignature } from "./PermitAuthorisationSignature";
import { EightPointCheckList } from "./EightPointCheckList";
import { CalibrationCertificate } from "./CalibrationCertificate";
import { Area } from "./Area";
import { SitePhoto } from "./SitePhoto";
import { Geofencing } from "./Geofencing";
import { PermitType } from "./PermitType";
import { PermitRegister } from "./PermitRegister";
import { PermitTemplate } from "./PermitTemplate";
import { PermitFieldValue } from "./PermitFieldValue";

export interface Permit {
    pendingSave?: boolean;
    pendingSync?: boolean;
    pendingStatusSync?: boolean;
    pendingStatusLoggedInUserId?: string;
    reportProblemComments?: string;
    id: string;
    permitNumber: number;
    comments: string;
    validFrom: Date;
    validTo: Date;
    locationOfWork: string;
    areas?: Area[];
    worksDescription: string;
    status: string;
    project: Project;
    permitWorkType: string;
    submittedById: string;
    dateSubmitted?: Date;
    maxPenetrationDepth: string;
    permittedEquipment: string;
    subContractor: string;
    affectedServices: PermitAffectedService[];
    documents: Document[];
    permitGangMembers: PermitGangMember[];
    signatures: PermitAuthorisationSignature[];
    emergencyContact?: EmergencyContact;
    sitePhotoFileKeys?: string[];
    sitePhotos?: SitePhoto[];
    lastAccess?: LocationLog;
    permitAssignments?: PermitAssignment[];
    eightPointCheckList: EightPointCheckList;
    shouldHaveGangMembers: boolean;
    calibrationCertificate?: CalibrationCertificate;
    geofencing?: Geofencing;
    permitType?: PermitType;
    permitRegister?: PermitRegister;
    template?: PermitTemplate;
    fieldValues?: PermitFieldValue[];
}

// TODO: we should remove permit.geofencing
export function getPermitGeofencing(permit: Permit): Geofencing | undefined {
    if (permit?.template?.features.gisBoundary) {
        return {
            status: permit.template.features.gisBoundary.enabled
                ? permit.template.features.gisBoundary.geofencingStatus.value
                : "disabled",
            toleranceMeters: permit.template.features.gisBoundary.geofencingToleranceMeters,
        } as Geofencing;
    }
    return permit.geofencing;
}
